"use client";

import dynamic from "next/dynamic";

const Footer = dynamic(() => import("./footer"), {
	ssr: false,
	loading: () => <footer className="h-64 animate-pulse bg-secondary/5" />,
});

export default function ClientFooter() {
	return <Footer />;
}
